import CourseAccessList from "../components/CourseAccessList";
import {Box, Breadcrumbs, Button, Typography} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {Link as RouterLink} from "react-router-dom";

const CourseAccessPage = () => {
    return (
        <Box sx = {{px: {xs: 3, md: 3}}}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>} sx={{mb: 2}}>
                <Button
                    component={RouterLink}
                    to="/"
                    variant="text"
                    sx={{textTransform: "none"}}
                >
                    Home Page
                </Button>
                <Typography color="text.primary">Course Access</Typography>
            </Breadcrumbs>
            <CourseAccessList/>
        </Box>
    );
};

export default CourseAccessPage;
